import { render, staticRenderFns } from "./Consignments.vue?vue&type=template&id=d1e9d40e&"
import script from "./Consignments.vue?vue&type=script&lang=js&"
export * from "./Consignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports